import React, { Component } from 'react'
import { Link } from 'react-router-dom'
import { Query, Mutation } from 'react-apollo'
import format from 'date-fns/format'

import { CONTENTS_QUERY, UPDATE_CONTENT_MUTATION } from 'graphql/queries'
import { FEATURED_TYPES } from 'config/constants'

import { Container, Header, Table, Button } from 'semantic-ui-react'
import InfiniteScroll from 'react-infinite-scroller'
import Input from 'components/Input'

const WEB_HOST = process.env.WEB_HOST

class Featured extends Component {
  state = {
    limit: 20,
    offset: 0,
    q: '',
    hasMore: true,
  }

  renderRow = ({ id, title, category, updated, lastModifiedBy }) => {
    const { limit, offset, q } = this.state
    const variables = { limit, offset, q, featuredType: FEATURED_TYPES.none }
    const displayName = lastModifiedBy
      ? `${lastModifiedBy.firstName} ${lastModifiedBy.lastName}`
      : 'Unknown'
    return (
      <Table.Row key={id}>
        <Table.Cell>
          <a
            target="_blank"
            rel="noopener noreferrer"
            href={`${WEB_HOST}/article/${id}`.replace('cms', 'ctt')}
          >
            {title}
          </a>
        </Table.Cell>
        <Table.Cell>{category}</Table.Cell>
        <Table.Cell>
          <span>{format(updated, 'MM/DD/YY, h:mm A')}</span>
          <br />
          <span>By {displayName}</span>
        </Table.Cell>
        <Table.Cell>
          <Mutation
            mutation={UPDATE_CONTENT_MUTATION}
            refetchQueries={[
              { query: CONTENTS_QUERY, variables },
              {
                query: CONTENTS_QUERY,
                variables: { featuredType: FEATURED_TYPES.queued },
              },
            ]}
          >
            {(updateContent, { loading }) => {
              return (
                <Button
                  loading={loading}
                  color="orange"
                  onClick={() => {
                    updateContent({
                      variables: {
                        id,
                        input: { featuredType: FEATURED_TYPES.queued },
                      },
                    })
                  }}
                >
                  Add to Queue
                </Button>
              )
            }}
          </Mutation>
        </Table.Cell>
      </Table.Row>
    )
  }

  renderTable = () => {
    const { limit, offset, q, hasMore } = this.state
    const variables = { limit, offset, q, featuredType: FEATURED_TYPES.none }
    return (
      <Query query={CONTENTS_QUERY} variables={variables}>
        {({ data, loading, fetchMore, error }) => {
          if (loading) {
            return <div>loading...</div>
          }

          if (error) {
            console.error(error)
            return <div>Error occurred fetching contents</div>
          }

          return (
            <Table>
              <InfiniteScroll
                loadMore={() =>
                  fetchMore({
                    variables: { offset: data.contents.length },
                    updateQuery: (prev, { fetchMoreResult, variables }) => {
                      if (!fetchMoreResult) return prev
                      if (!fetchMoreResult.contents.length) {
                        this.setState({ hasMore: false })
                      }
                      return {
                        ...prev,
                        contents: [
                          ...prev.contents,
                          ...fetchMoreResult.contents,
                        ],
                      }
                    },
                  })
                }
                hasMore={hasMore}
                loader={<div>loading...</div>}
              >
                <Table.Header>
                  <Table.Row>
                    <Table.HeaderCell width={4}>Title</Table.HeaderCell>
                    <Table.HeaderCell>Category</Table.HeaderCell>
                    <Table.HeaderCell>Last Modified</Table.HeaderCell>
                    <Table.HeaderCell>Actions</Table.HeaderCell>
                  </Table.Row>
                </Table.Header>

                <Table.Body>{data.contents.map(this.renderRow)}</Table.Body>
              </InfiniteScroll>
            </Table>
          )
        }}
      </Query>
    )
  }

  render() {
    return (
      <Container>
        <div style={{ display: 'flex', justifyContent: 'space-between' }}>
          <Header as="h1" content="Content Search" />
          <Link to="/featured">
            <Button primary>Back</Button>
          </Link>
        </div>
        <Input
          id="q"
          placeholder="Search for contents to feature..."
          minLength={2}
          debounceTimeout={300}
          value={this.state.q}
          onChange={event => this.setState({ q: event.target.value })}
        />
        {this.renderTable()}
      </Container>
    )
  }
}

export default Featured
